<!--
 * @Author: your name
 * @Date: 2021-09-09 13:51:58
 * @LastEditTime: 2021-09-10 18:10:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \taotan_admin\src\views\marriageGetName\babyName\babyMameDesSet.vue
-->
<template>
  <div class="badyname_des-contain" v-loading="pageLoading">
    <el-row>
      <el-tabs v-model="activeName" @tab-click="handleClickExplain">
        <el-tab-pane
          v-for="item in explainTypeData"
          :key="item.enumId"
          :label="item.enumName"
          :name="item.enumVal"
        ></el-tab-pane>
      </el-tabs>
    </el-row>
    <div class="public-dialog-form">
      <el-form
        ref="explainRuleForm"
        :rules="explainRules"
        :model="explainParams"
        label-width="80px"
      >
        <el-form-item label="标题" prop="name">
          <el-input
            type="text"
            placeholder="请填写标题"
            maxlength="32"
            v-model="explainParams.name"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="内容" prop="intro">
          <richText
            v-if="richTextMouted"
            :keyWord="'intro'"
            :params="explainParams ? explainParams : ''"
            ref="richText"
          ></richText>
        </el-form-item>
      </el-form>
    </div>
    <div class="babyname-set-btn">
      <el-button size="medium" type="primary" @click="modificationBabynameDes"
        >修 改</el-button
      >
    </div>
  </div>
</template>

<script>
import richText from "@/components/richText.vue";
export default {
  components: {
    richText,
  },
  data() {
    return {
      activeName: "syjs",
      explainTypeData: [
        { enumId: "syjs", enumName: "首页说明", enumVal: "syjs" },
        { enumId: "zfsm", enumName: "支付说明", enumVal: "zfsm" },
        { enumId: "cjwt", enumName: "常见问题", enumVal: "cjwt" },
        { enumId: "qmal1", enumName: "男宝宝案例", enumVal: "qmal1" },
        { enumId: "qmal2", enumName: "女宝宝案例", enumVal: "qmal2" },
      ],
      explainRules: {
        name: [{ required: true, message: "请填写标题", trigger: "change" }],
        intro: [{ required: true, message: "请填写详情", trigger: "change" }],
        // seq: [{
        //   // required: true,
        //  message: "请填写序号", trigger: "change" }],
      },
      explainParams: {
        name:''
      },
      pageLoading: false, // 页面加载loading
      intitleInfoId: this.$route.query.id,
      richTextMouted: false,
    };
  },
  watch: {
    activeName() {
      this.getBabyMameDes();
    },
  },
  created() {
    this.getBabyMameDes();
  },
  methods: {
    handleClickExplain() {},
    /*
     *@method: getBabyMameDes
     *@param:
     *@desc:  获取宝宝说明详情
     *@Date: 2021-09-10 10:57:49
     */
    async getBabyMameDes() {
      this.pageLoading = true;
      this.richTextMouted = false;
      const { data: resData } = await this.$get(
        `/intitle/intro/info/${this.intitleInfoId}/${this.activeName}`,{}
      );
      this.pageLoading = false;

      if (resData.result != 200) return;
      if(resData.data){
      this.explainParams = resData.data;
      }else {
        this.explainParams = {
          name:'',
          intitleInfoId:this.intitleInfoId
        }
      }
      this.richTextMouted = true;
    },
    /*
     *@method: modificationBabynameDes
     *@param:
     *@desc:  修改宝贝名称说明
     *@Date: 2021-09-10 11:19:48
     */
    modificationBabynameDes() {
      this.$refs.explainRuleForm.validate(async (valid) => {
        if (!valid) return;
        this.explainParams.intro = this.$refs.richText.myParams.intro;
        if (!this.explainParams.intro) {
          this.$message.warning(`请填写内容！`);
          return false;
        }
        this.pageLoading = true;
        if(this.explainParams.intitleIntroId){
          const { data: resData } = await this.$put(`/intitle/intro/info`, {
            introType: this.activeName,
            ...this.explainParams,
          });
          this.pageLoading = false;
          this.getBabyMameDes();
          if (resData.result != 200) return;
          this.$message.success("修改成功!");
        }else {
          const { data: resData } = await this.$post(`/intitle/intro/info`, {
            introType: this.activeName,
            ...this.explainParams,
          });
          this.pageLoading = false;
          this.getBabyMameDes();
          if (resData.result != 200) return;
          this.$message.success("新增成功!");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.badyname_des-contain {
  background: #ffffff;
  padding: 20px;
  .babyname-set-btn {
    padding-left: 80px;
  }
}
</style>
